import './styles';

import React from 'react';

const LoadingMessage = props => {
    return (
        <div className="LoadingMessage">
            <div className="LoadingMessage-image" />
            <div className="LoadingMessage-text">{props.text}</div>
        </div>
    );
};

LoadingMessage.defaultProps = {
    text: 'Loading…'
};

export default LoadingMessage;
